export async function detectInternetExplorer() {
    const ieVersion = getInternetExplorerVersion();
    if (ieVersion !== 0) {
        import('./polyfills');
        document.body.classList.add(`ie${ieVersion}`);
        document.body.classList.add('ie-fix');
        fixModalLinks();
    } 
}

function getInternetExplorerVersion() {
    let rv = 0, ua = "", re:RegExp
    if (navigator.appName === 'Microsoft Internet Explorer') {
        ua = navigator.userAgent;
        re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})");
        if (re.exec(ua) !== null) rv = parseFloat( RegExp.$1 );
    } else if (navigator.appName === 'Netscape') {
        ua = navigator.userAgent;
        re  = new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})");
        if (re.exec(ua) !== null) rv = parseFloat( RegExp.$1 );
    }
    return rv;
}

function fixModalLinks() {
    //Fix for removing href attributes from a.js-open-modal elements
    let jsOpenModalLinks = document.querySelectorAll('a.js-open-modal[href]');
    jsOpenModalLinks.forEach(el => {
        el.setAttribute('data-href', `${el.getAttribute('href')}?modal=true`);
        el.removeAttribute('href');
    });

    let jsOpenOffCanvasPanelLinks = document.querySelectorAll('a.js-open-off-canvas-panel[href]');
    jsOpenOffCanvasPanelLinks.forEach(el => {
        el.setAttribute('data-href', `${el.getAttribute('href')}`);
        el.removeAttribute('href');
    });

}
